var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7505 6.87429C11.7505 7.94991 11.4012 8.94351 10.8129 9.74965L13.7803 12.7187C14.0732 13.0117 14.0732 13.4874 13.7803 13.7803C13.4873 14.0732 13.0115 14.0732 12.7185 13.7803L9.75116 10.8112C8.94487 11.4017 7.95107 11.7486 6.87524 11.7486C4.18214 11.7486 2 9.56686 2 6.87429C2 4.18171 4.18214 2 6.87524 2C9.56834 2 11.7505 4.18171 11.7505 6.87429ZM6.87524 10.2488C7.31847 10.2488 7.75736 10.1615 8.16686 9.99192C8.57635 9.82234 8.94843 9.57377 9.26184 9.26042C9.57525 8.94707 9.82387 8.57507 9.99348 8.16565C10.1631 7.75624 10.2504 7.31743 10.2504 6.87429C10.2504 6.43114 10.1631 5.99233 9.99348 5.58292C9.82387 5.1735 9.57525 4.8015 9.26184 4.48815C8.94843 4.1748 8.57635 3.92623 8.16686 3.75665C7.75736 3.58706 7.31847 3.49978 6.87524 3.49978C6.432 3.49978 5.99311 3.58706 5.58362 3.75665C5.17412 3.92623 4.80205 4.1748 4.48864 4.48815C4.17522 4.8015 3.92661 5.1735 3.75699 5.58292C3.58737 5.99233 3.50007 6.43114 3.50007 6.87429C3.50007 7.31743 3.58737 7.75624 3.75699 8.16565C3.92661 8.57507 4.17522 8.94707 4.48864 9.26042C4.80205 9.57377 5.17412 9.82234 5.58362 9.99192C5.99311 10.1615 6.432 10.2488 6.87524 10.2488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch16W);
export default __webpack_public_path__ + "static/media/Search_16w.bd063a9e8efa6dd0d30220bd5b5207e8.svg";
export { ForwardRef as ReactComponent };